
/*
 *   File : bank-submission-success.js
 *   Author URI : https://evoqins.com
 *   Description : Confirm modal 
 *   Integrations : null
 *   Version : v1.1
 */

// Packages
import { Fragment, memo, useEffect } from "react";
import { Modal } from 'bootstrap';

// Custom components
import { PrimaryButton } from "../Buttons";

// Custom styles
import style from "../../Styles/Components/fund-allocation.module.scss";


// type  1 ---- success
// else failed

const AmountMissMatchInfo = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("amount-miss-match-info");
        my_modal.addEventListener("hidden.bs.modal", () => {
            // props.closeModal();
        });
        //eslint-disable-next-line
    }, []);

    function _closeModal() {
        // const modalEl = document.getElementById("amount-miss-match-info");
        // const modal = Modal.getInstance(modalEl) || Modal(modalEl);
        // modal.hide();
        document.getElementById("modal-close-primary").dispatchEvent(new Event("click"));
        if (props.backdrop) {
            document.getElementById("amount-miss-match-info").classList.remove("show");
            const backdrop = document.querySelector(".modal-backdrop.fade.show");
            if (backdrop) {
                backdrop.parentNode.removeChild(backdrop);
            }
            document.body.removeAttribute('style')
            props.closeModal();;
        }
        else {
             props.closeModal();
        }
    }


    return (
        <Fragment>
            <div className={`modal fade ${style.e_confirm_modal}`}
                id="amount-miss-match-info"
                tabIndex="-1"
                aria-labelledby="amount-miss-match-info"
                aria-hidden="true"
                data-bs-backdrop="static"
                data-bs-keyboard="false">
                <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}
                 onClick={(e) => e.stopPropagation()}>
                    <div className={`modal-content padding-36px-bottom  text-center padding-12px-lr ${style.e_content} `}>
                        {/* <Icon icon="close"
                            size={24}
                            id="close-modal"
                            data-bs-dismiss="modal"
                            className='cursor-pointer position-absolute right-16px top-16px' /> */}
                        {
                            <Fragment>
                                <img src={require("../../Assets/Images/warning_blue.png")}
                                    alt="success"
                                    draggable={false}
                                    width={144}
                                    height={144}
                                    className="mx-auto" />


                                <p className="e-montserrat-medium e-font-16 e-line-height-28 color-charcoal-gray mb-0 ">
                                    {` Your investment amount has been updated to ${props.amount} to comply with the minimum amount multiples of the constituent funds`}
                                </p>
                                <div className="row d-flex justify-content-center">
                                    <div className="col-6">
                                        <PrimaryButton label="Continue"
                                            id="modal-close-primary"
                                            className="w-100 padding-12px-tb mt-4"
                                            onPress={_closeModal}
                                        />
                                    </div>
                                </div>
                            </Fragment>
                        }
                    </div>

                </div>
            </div>
        </Fragment>
    )
}

AmountMissMatchInfo.defaultProps = {
    closeModal: () => { }
}

export default memo(AmountMissMatchInfo)